module.exports = __webpack_public_path__ + "img/information-variant-circle 1.7b782c36.svg";